<script setup lang="ts">
const items = [
  {
    title: 'Terintegrasi Real-Time',
    description:
      'Kirim pesan otomatis sesuai status pengiriman aktual, tanpa perlu API tambahan.',
    icon: 'material-symbols:all-inclusive'
  },
  {
    title: 'Format Pesan Fleksibel',
    description:
      'Ubah nama, gaya bahasa, CTA, dan link sesuai tone brand kamu.',
    icon: 'material-symbols:receipt-long-outline'
  },
  {
    title: 'Multistage Automation',
    description:
      'Sistem otomatis di tiap tahap: pickup - transit - delivered - review.',
    icon: 'material-symbols:dns-outline'
  },
  {
    title: 'Multi-Brand Support',
    description: 'Cocok untuk seller dengan beberapa toko atau brand berbeda.',
    icon: 'material-symbols:branding-watermark-outline'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Kenapa Whatsapp Follow-up KiriminAja Lebih Unggul?"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
